<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <custom-result-not-found v-if="items.length === 0" />
    <time-line class="mt-4">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <em
              class="radius"
              :class="
                `fas ${getBillingTrackingIcon(item.billingTrackingTypeId)}`
              "
            />
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-12">
                Fecha:
              </div>
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.createdDate | date }}
              </div>
              <div class="color-black font-12 font-weight-bold hour">
                {{ item.createdDate | hour }}
              </div>
            </div>
          </template>
          <div class="row pt-4 pb-2 mx-2">
            <div class="col-md-3">
              <label class="font-18 font-weight-bold ml-2">
                {{ item.billingTrackingTypeName }}
              </label>
            </div>

            <div class="col col-md-3">
              <div class="color-gray-6 font-14 font-weight-normal">
                Usuario:
              </div>
              <div class="color-black font-16 font-weight-normal label-value">
                {{ item.createUserName }}
              </div>
            </div>
            <div class="col col-md-3">
              <div class="color-gray-6 font-14 font-weight-normal">
                Nombre:
              </div>
              <div class="color-black font-16 font-weight-normal">
                {{ item.createUserFullName }}
              </div>
            </div>
            <div class="col col-md-3">
              <div class="color-gray-6 font-14 font-weight-normal">
                Estatus:
              </div>
              <div class="font-16 font-weight-normal">
                <em
                  class="fa fa-circle font-12 mt-1"
                  :class="`color-${getColorStatus(item.statusId)}`"
                />
                <span class="ml-1">{{ item.statusName | empty }}</span>
              </div>
            </div>
            <div
              v-if="item.comments"
              class="bg-white rounded col-md-12 p-2 mt-3"
            >
              <div class="ml-2 mb-1">
                <span
                  class="orange-icon orange-icon-badge-align fa fa-info-circle"
                />
                <span class="pl-2 font-14">Descripción:</span>
              </div>
              <div class="font-16 ml-2">
                <span class="comments">{{ item.comments | empty }}</span>
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
    <div
      v-if="
        pagination.totalItemCount > 0 &&
          pagination.totalItemCount > pagination.count
      "
      class="d-flex justify-content-center align-items-center mt-3"
    >
      <action-button
        class="btn-see-more"
        i="fas fa-chevron-down"
        text="Ver más"
        variant="outline-success rounded-pill px-5"
        @click="loadMore"
      />
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import { getHistory as _getHistory } from '@/services/provider/billing-history.api.js';
import billingTrackingTypes from '@/utils/constants/billingTrackingType.js';
import utilities from '@/utils/utilities.js';

const DEFAULT_PAGE_SIZE = 5;

export default {
  name: 'BillingHistoryDetail',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    billId: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    items: [],
    pagination: {
      currentPage: 1,
      totalItemCount: 1,
      pageCount: 1,
      count: 1,
      pageSize: DEFAULT_PAGE_SIZE,
    },
  }),
  computed: {
    getBillingTrackingIcon() {
      return (type) => {
        switch (type) {
          case billingTrackingTypes.CambioDeEstatus.id:
            return billingTrackingTypes.CambioDeEstatus.icon;
          case billingTrackingTypes.LogInterface.id:
            return billingTrackingTypes.LogInterface.icon;
          default:
            return billingTrackingTypes.Unset.icon;
        }
      };
    },
    getColorStatus() {
      return (statusId) => {
        return utilities.parseStateColorBillingByStatus(statusId);
      };
    },
  },
  async mounted() {
    await this.getHistory(DEFAULT_PAGE_SIZE);
  },
  methods: {
    async getHistory(pageSize) {
      const { data } = await _getHistory(this.billId, 1, pageSize);
      this.items = data.data;
      this.pagination = {
        ...this.pagination,
        count: data.count,
        currentPage: data.currentPage,
        pageCount: data.pageCount,
        totalItemCount: data.totalItemCount,
      };
    },
    async loadMore() {
      const pageSize = this.pagination.count + DEFAULT_PAGE_SIZE;
      await this.getHistory(pageSize);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.comments {
  padding-left: 26px;
}

::v-deep .custom-time-line {
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: map-get($colors, 'gray-2');
    color: map-get($colors, 'white');
    box-shadow: 0px 3px 6px #00000029;
  }
}

.date-container {
  text-align: right;
}

.orange-icon {
  color: #ff7058;
}

@media screen and (max-width: 768px) {
  ::v-deep div.balloon-container {
    display: none !important;
  }

  #circle-badged {
    display: block !important;
  }

  hr {
    display: block !important;
  }
}
</style>
